import React from 'react';
import CreateWidget from './CreateWidget';
import SelectedWidgets from './SelectedWidgets/SelectedWidgets';
import { Stack, mergeStyles } from '@fluentui/react';

const widgetsContainerStyles = mergeStyles({
    width: '100%',
    height: '100%',
    padding: '20px'
});

const Widgets: React.FC = () => {
    return (
        <Stack className={widgetsContainerStyles}>
            <SelectedWidgets />
            <CreateWidget />
        </Stack>
    );
};

export default Widgets;
